<template>
  <div class="chart-empty-state" :style="{ minHeight: height }">
    <div class="chart-empty-icon" aria-hidden="true">
      <i :class="icon"></i>
    </div>
    <p class="chart-empty-title">{{ resolvedTitle }}</p>
    <p v-if="resolvedSubtitle" class="chart-empty-sub">{{ resolvedSubtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "ChartEmptyState",
  props: {
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: "fas fa-chart-area",
    },
    height: {
      type: String,
      default: "156px",
    },
  },
  computed: {
    resolvedTitle() {
      return this.title ?? this.$t("commonNoData");
    },
    resolvedSubtitle() {
      return this.subtitle ?? this.$t("commonNoIndicator");
    },
  },
};
</script>

<style scoped>
.chart-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1.25rem 1rem;
  border: 1px dashed var(--app-border-strong);
  border-radius: 10px;
  background-color: var(--app-surface-soft);
  text-align: center;
  color: var(--app-text);
}

.chart-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.45rem;
  height: 2.45rem;
  margin-bottom: 0.5rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--bs-info) 16%, var(--app-surface));
  color: var(--bs-info);
  font-size: 0.95rem;
}

.chart-empty-title {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--app-heading);
}

.chart-empty-sub {
  margin: 0.28rem 0 0;
  max-width: 16rem;
  font-size: 0.76rem;
  line-height: 1.35;
  color: var(--app-text);
}
</style>
